import React, { useState, useEffect } from 'react'
import { X, User, Phone, Shield } from 'lucide-react'
import styles from './AddManagerModal.module.scss'

const EditManagerModal = ({ isOpen, onClose, manager, onUpdate, loading }) => {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    permissions: {
      viewDashboard: true,
      viewProducts: true,
      addProduct: false,
      editProduct: false,
      deleteProduct: false,
      viewPurchases: true,
      addPurchase: false,
      editPurchase: false,
      deletePurchase: false,
      exportData: false,
      viewSettings: false,
    },
  })

  const [errors, setErrors] = useState({})

  useEffect(() => {
    if (manager) {
      setFormData({
        name: manager.name || '',
        phone: manager.phone || '',
        permissions: manager.permissions || {
          viewDashboard: true,
          viewProducts: true,
          addProduct: false,
          editProduct: false,
          deleteProduct: false,
          viewPurchases: true,
          addPurchase: false,
          editPurchase: false,
          deletePurchase: false,
          exportData: false,
          viewSettings: false,
        },
      })
    }
  }, [manager])

  if (!isOpen) return null

  const validateForm = () => {
    const newErrors = {}

    if (!formData.name.trim()) {
      newErrors.name = 'Le nom est requis'
    }

    if (!formData.phone.trim()) {
      newErrors.phone = 'Le téléphone est requis'
    } else if (!/^\+224\d{9}$/.test(formData.phone.replace(/\s/g, ''))) {
      newErrors.phone =
        'Numéro de téléphone invalide. Le numéro doit commencer par +224 et contenir 9 chiffres.'
    }

    setErrors(newErrors)
    return Object.keys(newErrors).length === 0
  }

  const handleSubmit = (e) => {
    e.preventDefault()

    if (!validateForm()) return

    onUpdate(manager._id, formData)
  }

  const handlePermissionChange = (permission) => {
    setFormData((prev) => ({
      ...prev,
      permissions: {
        ...prev.permissions,
        [permission]: !prev.permissions[permission],
      },
    }))
  }

  //   const handleSelectAllProducts = () => {
  //     const allSelected =
  //       formData.permissions.addProduct &&
  //       formData.permissions.editProduct &&
  //       formData.permissions.deleteProduct

  //     setFormData((prev) => ({
  //       ...prev,
  //       permissions: {
  //         ...prev.permissions,
  //         addProduct: !allSelected,
  //         editProduct: !allSelected,
  //         deleteProduct: !allSelected,
  //       },
  //     }))
  //   }

  //   const handleSelectAllPurchases = () => {
  //     const allSelected =
  //       formData.permissions.addPurchase &&
  //       formData.permissions.editPurchase &&
  //       formData.permissions.deletePurchase

  //     setFormData((prev) => ({
  //       ...prev,
  //       permissions: {
  //         ...prev.permissions,
  //         addPurchase: !allSelected,
  //         editPurchase: !allSelected,
  //         deletePurchase: !allSelected,
  //       },
  //     }))
  //   }

  return (
    // <div className='modal-overlay' onClick={onClose}>
    //   <div className='modal-content' onClick={(e) => e.stopPropagation()}>
    //     <div className='modal-header'>
    //       <h2>
    //         <Shield size={24} />
    //         Modifier le gérant
    //       </h2>
    //       <button onClick={onClose} className='modal-close'>
    //         <X size={20} />
    //       </button>
    //     </div>

    //     <form onSubmit={handleSubmit} className='modal-body'>
    //       {/* Informations de base */}
    //       <div className='form-section'>
    //         <h3>Informations personnelles</h3>

    //         <div className='form-field'>
    //           <label>
    //             <User size={16} />
    //             Nom complet *
    //           </label>
    //           <input
    //             type='text'
    //             value={formData.name}
    //             onChange={(e) =>
    //               setFormData({ ...formData, name: e.target.value })
    //             }
    //             placeholder='Ex: Mamadou Diallo'
    //             className={errors.name ? 'error' : ''}
    //           />
    //           {errors.name && (
    //             <span className='error-message'>{errors.name}</span>
    //           )}
    //         </div>

    //         <div className='form-field'>
    //           <label>
    //             <Phone size={16} />
    //             Téléphone *
    //           </label>
    //           <input
    //             type='tel'
    //             value={formData.phone}
    //             onChange={(e) =>
    //               setFormData({ ...formData, phone: e.target.value })
    //             }
    //             placeholder='Ex: 621234567'
    //             className={errors.phone ? 'error' : ''}
    //           />
    //           {errors.phone && (
    //             <span className='error-message'>{errors.phone}</span>
    //           )}
    //           <small className='field-hint'>
    //             Le gérant devra utiliser ce nouveau numéro pour se connecter
    //           </small>
    //         </div>
    //       </div>

    //       {/* Permissions */}
    //       <div className='form-section'>
    //         <h3>Permissions d'accès</h3>

    //         {/* Dashboard */}
    //         <div className='permission-group'>
    //           <h4>Tableau de bord</h4>
    //           <label className='permission-item'>
    //             <input
    //               type='checkbox'
    //               checked={formData.permissions.viewDashboard}
    //               onChange={() => handlePermissionChange('viewDashboard')}
    //             />
    //             <span>Voir le tableau de bord</span>
    //           </label>
    //         </div>

    //         {/* Produits */}
    //         <div className='permission-group'>
    //           <div className='permission-group-header'>
    //             <h4>Produits</h4>
    //             <button
    //               type='button'
    //               onClick={handleSelectAllProducts}
    //               className='btn-text'
    //             >
    //               Tout sélectionner
    //             </button>
    //           </div>

    //           <label className='permission-item'>
    //             <input
    //               type='checkbox'
    //               checked={formData.permissions.viewProducts}
    //               onChange={() => handlePermissionChange('viewProducts')}
    //             />
    //             <span>Voir les produits</span>
    //           </label>

    //           <label className='permission-item indent'>
    //             <input
    //               type='checkbox'
    //               checked={formData.permissions.addProduct}
    //               onChange={() => handlePermissionChange('addProduct')}
    //               disabled={!formData.permissions.viewProducts}
    //             />
    //             <span>Ajouter des produits</span>
    //           </label>

    //           <label className='permission-item indent'>
    //             <input
    //               type='checkbox'
    //               checked={formData.permissions.editProduct}
    //               onChange={() => handlePermissionChange('editProduct')}
    //               disabled={!formData.permissions.viewProducts}
    //             />
    //             <span>Modifier les produits</span>
    //           </label>

    //           <label className='permission-item indent'>
    //             <input
    //               type='checkbox'
    //               checked={formData.permissions.deleteProduct}
    //               onChange={() => handlePermissionChange('deleteProduct')}
    //               disabled={!formData.permissions.viewProducts}
    //             />
    //             <span>Supprimer les produits</span>
    //           </label>
    //         </div>

    //         {/* Achats */}
    //         <div className='permission-group'>
    //           <div className='permission-group-header'>
    //             <h4>Achats</h4>
    //             <button
    //               type='button'
    //               onClick={handleSelectAllPurchases}
    //               className='btn-text'
    //             >
    //               Tout sélectionner
    //             </button>
    //           </div>

    //           <label className='permission-item'>
    //             <input
    //               type='checkbox'
    //               checked={formData.permissions.viewPurchases}
    //               onChange={() => handlePermissionChange('viewPurchases')}
    //             />
    //             <span>Voir les achats</span>
    //           </label>

    //           <label className='permission-item indent'>
    //             <input
    //               type='checkbox'
    //               checked={formData.permissions.addPurchase}
    //               onChange={() => handlePermissionChange('addPurchase')}
    //               disabled={!formData.permissions.viewPurchases}
    //             />
    //             <span>Enregistrer des achats</span>
    //           </label>

    //           <label className='permission-item indent'>
    //             <input
    //               type='checkbox'
    //               checked={formData.permissions.editPurchase}
    //               onChange={() => handlePermissionChange('editPurchase')}
    //               disabled={!formData.permissions.viewPurchases}
    //             />
    //             <span>Modifier les achats</span>
    //           </label>

    //           <label className='permission-item indent'>
    //             <input
    //               type='checkbox'
    //               checked={formData.permissions.deletePurchase}
    //               onChange={() => handlePermissionChange('deletePurchase')}
    //               disabled={!formData.permissions.viewPurchases}
    //             />
    //             <span>Supprimer les achats</span>
    //           </label>
    //         </div>

    //         {/* Autres permissions */}
    //         <div className='permission-group'>
    //           <h4>Autres permissions</h4>

    //           <label className='permission-item'>
    //             <input
    //               type='checkbox'
    //               checked={formData.permissions.exportData}
    //               onChange={() => handlePermissionChange('exportData')}
    //             />
    //             <span>Exporter les données</span>
    //           </label>

    //           <label className='permission-item'>
    //             <input
    //               type='checkbox'
    //               checked={formData.permissions.viewSettings}
    //               onChange={() => handlePermissionChange('viewSettings')}
    //             />
    //             <span>Accéder aux paramètres</span>
    //           </label>
    //         </div>
    //       </div>

    //       <div className='modal-actions'>
    //         <button
    //           type='button'
    //           onClick={onClose}
    //           className='btn secondary'
    //           disabled={loading}
    //         >
    //           Annuler
    //         </button>
    //         <button type='submit' className='btn primary' disabled={loading}>
    //           {loading ? 'Modification en cours...' : 'Modifier le gérant'}
    //         </button>
    //       </div>
    //     </form>
    //   </div>
    // </div>
    <div className={styles.modalOverlay} onClick={onClose}>
      <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
        <div className={styles.modalHeader}>
          <h2>
            <Shield size={24} />
            Modifier le gérant
          </h2>
          <button
            onClick={() => {
              setErrors({})
              onClose()
            }}
            className={styles.modalClose}
          >
            <X size={20} />
          </button>
        </div>

        <form onSubmit={handleSubmit} className={styles.modalBody}>
          {/* Informations personnelles */}
          <div className={styles.formSection}>
            <h3>Informations personnelles</h3>

            <div className={styles.formField}>
              <label>
                <User size={16} />
                Nom complet *
              </label>
              <input
                type='text'
                value={formData.name}
                onChange={(e) =>
                  setFormData({ ...formData, name: e.target.value })
                }
                placeholder='Ex: Mamadou Diallo'
                className={errors.name ? styles.error : ''}
              />
            </div>

            <div className={styles.formField}>
              <label>
                <Phone size={16} />
                Téléphone *
              </label>
              <input
                type='tel'
                value={formData.phone}
                onChange={(e) =>
                  setFormData({ ...formData, phone: e.target.value })
                }
                placeholder='Ex: +224621234567'
                className={errors.phone ? styles.error : ''}
              />
              <small className={styles.fieldHint}>
                Le gérant recevra un code de vérification sur ce numéro pour se
                connecter
              </small>
            </div>
          </div>

          {/* Permissions */}
          <div className={styles.formSection}>
            <h3>Permissions d'accès</h3>

            <div className={styles.permissionGroup}>
              <h4>Tableau de bord</h4>
              <label className={styles.permissionItem}>
                <input
                  type='checkbox'
                  checked={formData.permissions.viewDashboard}
                  onChange={() => handlePermissionChange('viewDashboard')}
                />
                <span>Voir le tableau de bord</span>
              </label>
            </div>

            <div className={styles.permissionGroup}>
              <div className={styles.permissionGroupHeader}>
                <h4>Produits</h4>
                {/* <button
                  type='button'
                  onClick={handleSelectAllProducts}
                  className={styles.btnText}
                >
                  Tout sélectionner
                </button> */}
              </div>

              <label className={styles.permissionItem}>
                <input
                  type='checkbox'
                  checked={formData.permissions.viewProducts}
                  onChange={() => handlePermissionChange('viewProducts')}
                />
                <span>Accéder aux produits</span>
                {/* <span>Voir les produits</span> */}
              </label>

              {/* <label className={`${styles.permissionItem} ${styles.indent}`}>
                <input
                  type='checkbox'
                  checked={formData.permissions.addProduct}
                  onChange={() => handlePermissionChange('addProduct')}
                  disabled={!formData.permissions.viewProducts}
                />
                <span>Ajouter des produits</span>
              </label>

              <label className={`${styles.permissionItem} ${styles.indent}`}>
                <input
                  type='checkbox'
                  checked={formData.permissions.editProduct}
                  onChange={() => handlePermissionChange('editProduct')}
                  disabled={!formData.permissions.viewProducts}
                />
                <span>Modifier les produits</span>
              </label>

              <label className={`${styles.permissionItem} ${styles.indent}`}>
                <input
                  type='checkbox'
                  checked={formData.permissions.deleteProduct}
                  onChange={() => handlePermissionChange('deleteProduct')}
                  disabled={!formData.permissions.viewProducts}
                />
                <span>Supprimer les produits</span>
              </label> */}
            </div>

            <div className={styles.permissionGroup}>
              <div className={styles.permissionGroupHeader}>
                <h4>Achats</h4>
                {/* <button
                  type='button'
                  onClick={handleSelectAllPurchases}
                  className={styles.btnText}
                >
                  Tout sélectionner
                </button> */}
              </div>

              <label className={styles.permissionItem}>
                <input
                  type='checkbox'
                  checked={formData.permissions.viewPurchases}
                  onChange={() => handlePermissionChange('viewPurchases')}
                />
                <span>Accéder aux achats</span>
                {/* <span>Voir les achats</span> */}
              </label>

              {/* <label className={`${styles.permissionItem} ${styles.indent}`}>
                <input
                  type='checkbox'
                  checked={formData.permissions.addPurchase}
                  onChange={() => handlePermissionChange('addPurchase')}
                  disabled={!formData.permissions.viewPurchases}
                />
                <span>Enregistrer des achats</span>
              </label>

              <label className={`${styles.permissionItem} ${styles.indent}`}>
                <input
                  type='checkbox'
                  checked={formData.permissions.editPurchase}
                  onChange={() => handlePermissionChange('editPurchase')}
                  disabled={!formData.permissions.viewPurchases}
                />
                <span>Modifier les achats</span>
              </label>

              <label className={`${styles.permissionItem} ${styles.indent}`}>
                <input
                  type='checkbox'
                  checked={formData.permissions.deletePurchase}
                  onChange={() => handlePermissionChange('deletePurchase')}
                  disabled={!formData.permissions.viewPurchases}
                />
                <span>Supprimer les achats</span>
              </label> */}
            </div>

            <div className={styles.permissionGroup}>
              <h4>Autres permissions</h4>

              <label className={styles.permissionItem}>
                <input
                  type='checkbox'
                  checked={formData.permissions.exportData}
                  onChange={() => handlePermissionChange('exportData')}
                />
                <span>Exporter les données</span>
              </label>

              {/* <label className={styles.permissionItem}>
                <input
                  type='checkbox'
                  checked={formData.permissions.viewSettings}
                  onChange={() => handlePermissionChange('viewSettings')}
                />
                <span>Accéder aux paramètres</span>
              </label> */}
            </div>
          </div>

          <div className={styles.modalActions}>
            <button
              type='button'
              onClick={() => {
                setErrors({})
                onClose()
              }}
              className={styles.btnSecondary}
              disabled={loading}
            >
              Annuler
            </button>
            <button
              type='submit'
              className={styles.btnPrimary}
              disabled={loading}
            >
              {loading ? 'Modification en cours...' : 'Modifier le gérant'}
            </button>

            {(errors.phone || errors.name) && (
              <div className={styles.errorSection}>
                {errors.name && (
                  <span className={styles.errorMessage}>{errors.name}</span>
                )}
                {errors.phone && (
                  <span className={styles.errorMessage}>{errors.phone}</span>
                )}
              </div>
            )}
          </div>
        </form>
      </div>
    </div>
  )
}

export default EditManagerModal
